export class NetworkSelectionWizardConfig {
  public enabled?: boolean;

  constructor(config?: NetworkSelectionWizardConfig) {
    config = config || {};
    this.enabled = (config && config.enabled) || false;
  }
}
